import StepTitle from './StepTitle';

const SalaryTitle = () => (
  <StepTitle
    eyebrow="Salary"
    title="Set Compensation"
    description="Including a salary range helps attract more qualified applicants. Listings without pay details usually receive fewer responses."
  />
);

export default SalaryTitle;
